import GetSchemeWiseSummary from "../components/schemeSummary/GetSchemeWiseSummary";
import React from "react";

const SchemeWiseSummaryPage = () =>{
     
    return(
         <>
           <GetSchemeWiseSummary/>
         </>
    )
}
export default SchemeWiseSummaryPage;